import React, { useState, useEffect, useRef } from "react";
import Stack from "@mui/material/Stack";
import {
  TextField,
  Box,
  MenuItem,
  Avatar,
  Paper,
  Button,
  Alert as MuiInlineAlert,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { LoadingButton } from "@mui/lab";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axiosInstance from "../../Api/axios.instance";
import { useFormik } from "formik";
import * as yup from "yup";
import useSession from "../../CustomHooks/useSession";
import Autocomplete from "@mui/material/Autocomplete";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EXPERIENCE_OPTIONS = [
  "0 – 1 year ",
  "1 – 3 years",
  "3 – 5 years",
  "5 – 10 years",
  "10+ years",
];

const validationSchema = yup.object({
  TeacherName: yup.string("Enter Full Name").required("Full Name is required"),
  CNIC: yup
    .string("Enter CNIC No")
    .matches(/^[0-9]+$/, "CNIC must be numbers only")
    .required("CNIC No is required"),
  TeachersDesignationId: yup.string().required("Designation is required"),

  Address: yup.string("Enter Address").trim().required("Address is required"),

  DateOfBirth: yup
    .string("Enter Date of Birth")
    .required("Date of Birth is required"),

  DateJoining: yup
    .string("Enter Date Joining")
    .required("Date of Joining is required"),

  Allowance: yup.string("Enter Allowance").required("Allowance is required"),

  FirstSalary: yup
    .string("Enter Your First Salary")
    .required("First Salary is required"),

  QualificationId: yup
    .string("Enter Your Qualification")
    .required("Qualification is required"),

  CertificateId: yup
    .string("Enter Your Certification")
    .required("Certificate is required"),

  // ExperienceOfTeaching: yup
  //   .string("Enter Experience of Teaching")
  //   .required("Experience in Teaching is required"),

  // TypeOfHiring: yup
  //   .string("Enter Type of Hiring")
  //   .required("Type of Hiring is required"),

  HiredSubject: yup
    .string("Enter Hired Subject")
    .required("Hired Subject is required"),

  // IsPrimary: yup
  //   .string("Enter Primary/Secondary")
  //   .required("Primary / Secondary is required"),
});

const _addTeacher = async (formData) => {
  const { data: response, status } = await axiosInstance.post(
    "/teachers/register",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  const SchoolID = JSON.parse(localStorage.getItem("UserAccess"))[0].SchoolId;
  const UserId = JSON.parse(localStorage.User).username;
  const formDataObj = {};
  formData.forEach((value, key) => {
    formDataObj[key] = value;
  });
  const logParams = {
    user_id: UserId,
    school_id: SchoolID,
    module: "Staff",
    data: JSON.stringify(formDataObj),
    DML_type: "Create",
  };
  await axiosInstance.post("/activity_trails/create_activity_trail", logParams);
  return status === 200 ? response : null;
};

export default function AddStaff({
  getStaff,
  classes,
  subjects,
  staff,
  onTeacherCreated,
}) {
  const [schoolId, setSchoolId] = useState(null);
  const [imgBase, setImgBase] = useState("");
  const [designations, setDesignations] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const inputFile = useRef(null);
  const { accesLevel, access } = useSession();

  // ---- Step 2: assign subject inline state ----
  // const [createdTeacher, setCreatedTeacher] = useState(null);
  // const [selectTeacher, setSelectTeacher] = useState(null);
  // const [selectClasses, setSelectClasses] = useState([]);
  // const [selectSubject, setSelectSubject] = useState(null);
  // const [dateAssigned, setDateAssigned] = useState(dayjs());
  // const [assignLoading, setAssignLoading] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (accesLevel === "SCHOOL") {
      const accessObject = Object.assign({}, access);
      setSchoolId(accessObject[0].SchoolId);
    }
    if (accesLevel === "ADMIN" || accesLevel === "CLUSTER") {
      const schoolID = JSON.parse(localStorage.getItem("UserAccess"))[0]
        .SchoolId;
      setSchoolId(schoolID);
    }
    _fetchDesignations();
    _fetchQualifications();
    _fetchCertifications();
  }, []);

  const _fetchDesignations = async () => {
    try {
      const { data, status } = await axiosInstance.get(
        "/teachers/designations",
      );
      if (status === 200) setDesignations(data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const _fetchQualifications = async () => {
    try {
      const { data, status } = await axiosInstance.get(
        "/teachers/qualifications",
      );
      if (status === 200) setQualifications(data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const _fetchCertifications = async () => {
    try {
      const { data, status } = await axiosInstance.get(
        "/teachers/certifications",
      );
      if (status === 200) setCertifications(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const _fetchRehireTeacher = async (cnic) => {
    if (!cnic || cnic.trim() === "") return;

    try {
      const { data, status } = await axiosInstance.get(
        `/teachers/rehire-by-cnic/${encodeURIComponent(cnic.trim())}`,
      );

      if (status === 200 && data.success && data.data) {
        const teacher = data.data;

        formik.setValues({
          ...formik.values,

          TeacherPicture: "",
          TeacherName: teacher.TeacherName || "",
          CNIC: teacher.CNIC || cnic,

          TeachersDesignationId:
            teacher.TeachersDesignationId?.toString() || "",

          Address: teacher.Address || "",
          ContactNo: teacher.ContactNo ? String(teacher.ContactNo).trim() : "",

          DateOfBirth: teacher.DateOfBirth
            ? dayjs(teacher.DateOfBirth).format("YYYY-MM-DD")
            : "",

          DateJoining: "",

          QualificationId: teacher.QualificationId?.toString() || "",

          CertificateId: teacher.CertificateId?.toString() || "",

          FirstSalary: teacher.FirstSalary ?? "",
          Allowance: teacher.Allowance ?? "",

          MaritalStatus: teacher.MaritalStatus || "",

          ExperienceOfTeaching: teacher.ExperienceOfTeaching || "",

          SubjectOfExperience: teacher.SubjectOfExperience || "",

          HiredSubject: teacher.HiredSubject || "",

          SalaryDemand: teacher.SalaryDemand || "",

          BankAccount: teacher.BankAccount || "",

          IsPrimary:
            teacher.IsPrimary === true || teacher.IsPrimary === 1
              ? "Primary"
              : teacher.IsPrimary === 2
                ? "KG"
                : teacher.IsPrimary === false || teacher.IsPrimary === 0
                  ? "Secondary"
                  : "",

          TypeOfHiring: "Rehire",
        });

        setSnack({
          open: true,
          severity: "success",
          message: "Previous teacher record found and form has been filled.",
        });
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        setSnack({
          open: true,
          severity: "warning",
          message: "No previous teacher record found for this CNIC.",
        });
      } else {
        setSnack({
          open: true,
          severity: "error",
          message:
            error?.response?.data?.message ||
            "Unable to fetch previous teacher record.",
        });
      }
    }
  };

  const isNonTeaching = (designationId) => {
    const selectedDesignation = designations.find(
      (d) => String(d.TeachersDesignationId) === String(designationId),
    );

    return ["NonTeaching-Maid", "NonTeaching-GateKeeper"].includes(
      selectedDesignation?.TeachersDesignation?.trim(),
    );
  };

  const formik = useFormik({
    initialValues: {
      TeacherPicture: "",
      TeacherName: "",
      CNIC: "",
      TeachersDesignationId: "",
      Address: "",
      ContactNo: "",
      DateOfBirth: "",
      DateJoining: "",
      QualificationId: "",
      CertificateId: "",
      FirstSalary: "",
      Allowance: "",
      MaritalStatus: "",
      ExperienceOfTeaching: "",
      SubjectOfExperience: "",
      HiredSubject: "",
      SalaryDemand: "",
      BankAccount: "",
      IsPrimary: "",
      TypeOfHiring: "",
    },
    // validationSchema: validationSchema,
    validationSchema: validationSchema.shape({
      ExperienceOfTeaching: yup
        .string()
        .test(
          "required-for-teaching",
          "Experience in Teaching is required",
          function (value) {
            return (
              isNonTeaching(this.parent.TeachersDesignationId) || Boolean(value)
            );
          },
        ),

      TypeOfHiring: yup
        .string()
        .test(
          "required-for-teaching",
          "Type of Hiring is required",
          function (value) {
            return (
              isNonTeaching(this.parent.TeachersDesignationId) || Boolean(value)
            );
          },
        ),

      IsPrimary: yup
        .string()
        .test(
          "required-for-teaching",
          "Primary / Secondary is required",
          function (value) {
            return (
              isNonTeaching(this.parent.TeachersDesignationId) || Boolean(value)
            );
          },
        ),
    }),
    validateOnChange: false,
    // validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      for (let key in values) {
        formData.append(key, values[key] ?? "");
      }
      formData.append("SchoolDetailShiftId", schoolId);

      const UserId = JSON.parse(localStorage.User).username;
      formData.append("DataEntryOperator", UserId);
      formData.append("DateDataEntry", dayjs().format("YYYY-MM-DD"));

      const newTeacher = await _addTeacher(formData);
      if (newTeacher && newTeacher.success) {
        await getStaff();
        setImgBase("");
        resetForm();
        setSnack({
          open: true,
          severity: "success",
          message: "Teacher has been added successfully.",
        });
      } else {
        setSnack({
          open: true,
          severity: "error",
          message: "An error occurred.",
        });
      }
    },
  });

  const _openFileDialog = () => {
    if (imgBase !== "") {
      setImgBase("");
      formik.setFieldValue("TeacherPicture", "");
      return;
    }
    inputFile.current.click();
  };

  const _onImageSelect = async (e) => {
    const file = e.currentTarget.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      alert("File size must be less than 2MB.");
      return;
    }
    formik.setFieldValue("TeacherPicture", file);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => setImgBase(event.target?.result);
  };

  const snack_handleClose = () =>
    setSnack((prev) => ({ ...prev, open: false }));

  return (
    <Box>
      <Box component="form" onSubmit={formik.handleSubmit}>
        {/* Picture — always first */}
        <Stack sx={{ mb: 3 }}>
          <Paper sx={{ p: 1, width: 150 }} square>
            <Avatar
              variant="square"
              src={
                imgBase === ""
                  ? "https://www.pngitem.com/pimgs/m/99-998739_dale-engen-person-placeholder-hd-png-download.png"
                  : imgBase
              }
              sx={{ width: 130, height: 130, objectFit: "cover" }}
            />
            <Stack
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              sx={{ mt: 1 }}
            >
              <Button
                onClick={_openFileDialog}
                size="small"
                variant="text"
                color={imgBase === "" ? "primary" : "error"}
              >
                {imgBase === "" ? "Select Picture" : "Remove Picture"}
              </Button>
              <input
                name="TeacherPicture"
                type="file"
                accept="image/*"
                ref={inputFile}
                onChange={_onImageSelect}
                hidden
              />
            </Stack>
          </Paper>
        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          sx={{ mb: 2 }}
          spacing={{ xs: 2, sm: 4 }}
        >
          <TextField
            size="small"
            label="Full Name"
            variant="outlined"
            sx={{ flex: 1 }}
            name="TeacherName"
            error={
              formik.touched.TeacherName && Boolean(formik.errors.TeacherName)
            }
            helperText={formik.touched.TeacherName && formik.errors.TeacherName}
            value={formik.values.TeacherName}
            onChange={formik.handleChange}
          />
          <TextField
            size="small"
            label="CNIC"
            variant="outlined"
            sx={{ flex: 1 }}
            name="CNIC"
            type="text"
            error={formik.touched.CNIC && Boolean(formik.errors.CNIC)}
            helperText={formik.touched.CNIC && formik.errors.CNIC}
            value={formik.values.CNIC}
            onChange={formik.handleChange}
          />
          <TextField
            size="small"
            select
            label="Designation"
            variant="outlined"
            sx={{ flex: 1 }}
            name="TeachersDesignationId"
            value={formik.values.TeachersDesignationId}
            // onChange={formik.handleChange}
            onChange={(e) => {
              const designationId = e.target.value;

              formik.setFieldValue("TeachersDesignationId", designationId);

              if (isNonTeaching(designationId)) {
                formik.setFieldValue("TypeOfHiring", "");
                formik.setFieldValue("ExperienceOfTeaching", "");
                formik.setFieldValue("IsPrimary", "");

                formik.setFieldTouched("TypeOfHiring", false, false);
                formik.setFieldTouched("ExperienceOfTeaching", false, false);
                formik.setFieldTouched("IsPrimary", false, false);
              }
            }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.TeachersDesignationId &&
              Boolean(formik.errors.TeachersDesignationId)
            }
            helperText={
              formik.touched.TeachersDesignationId &&
              formik.errors.TeachersDesignationId
            }
          >
            {designations.map((d) => (
              <MenuItem
                key={d.TeachersDesignationId}
                value={d.TeachersDesignationId}
              >
                {d.TeachersDesignation}
              </MenuItem>
            ))}
          </TextField>
        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          sx={{ mb: 2 }}
          spacing={{ xs: 2, sm: 4 }}
        >
          <TextField
            size="small"
            select
            label="Type of Hiring"
            variant="outlined"
            sx={{ flex: 1 }}
            name="TypeOfHiring"
            disabled={isNonTeaching(formik.values.TeachersDesignationId)}
            value={formik.values.TypeOfHiring}
            // onChange={formik.handleChange}
            onChange={(e) => {
              const hiringType = e.target.value;

              formik.setFieldValue("TypeOfHiring", hiringType);

              if (hiringType === "Rehire") {
                const cnic = formik.values.CNIC?.trim();

                if (!cnic) {
                  setSnack({
                    open: true,
                    severity: "warning",
                    message: "Please enter CNIC first.",
                  });

                  return;
                }

                _fetchRehireTeacher(cnic);
              }
            }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.TypeOfHiring && Boolean(formik.errors.TypeOfHiring)
            }
            helperText={
              formik.touched.TypeOfHiring && formik.errors.TypeOfHiring
            }
          >
            <MenuItem value="">Select</MenuItem>
            <MenuItem value="New Teacher">New Teacher</MenuItem>
            <MenuItem value="Replacement">Replacement</MenuItem>
            <MenuItem value="Rehire">Rehire</MenuItem>
            <MenuItem value="Helper">Helper</MenuItem>
          </TextField>
          <TextField
            size="small"
            label="Address"
            variant="outlined"
            sx={{ flex: 1 }}
            name="Address"
            value={formik.values.Address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.Address && Boolean(formik.errors.Address)}
            helperText={formik.touched.Address && formik.errors.Address}
          />
          <TextField
            size="small"
            type="number"
            label="Contact No"
            variant="outlined"
            sx={{ flex: 1 }}
            name="ContactNo"
            value={formik.values.ContactNo}
            onChange={formik.handleChange}
          />
        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          sx={{ mb: 2 }}
          spacing={{ xs: 2, sm: 4 }}
        >
          <TextField
            size="small"
            select
            label="Marital Status"
            sx={{ flex: 1 }}
            variant="outlined"
            name="MaritalStatus"
            value={formik.values.MaritalStatus}
            onChange={formik.handleChange}
          >
            <MenuItem value="">Select</MenuItem>
            <MenuItem value="Single">Single</MenuItem>
            <MenuItem value="Married">Married</MenuItem>
            <MenuItem value="Divorced">Divorced</MenuItem>
            <MenuItem value="Widowed">Widowed</MenuItem>
          </TextField>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              label="Date of Birth"
              inputFormat="DD-MM-YYYY"
              value={
                formik.values.DateOfBirth
                  ? dayjs(formik.values.DateOfBirth)
                  : null
              }
              onChange={(v) => {
                formik.setFieldValue(
                  "DateOfBirth",
                  v && dayjs(v).isValid() ? dayjs(v).format("YYYY-MM-DD") : "",
                );
              }}
              onClose={() => formik.setFieldTouched("DateOfBirth", true)}
              renderInput={(params) => (
                <TextField
                  size="small"
                  {...params}
                  sx={{ flex: 1 }}
                  error={
                    formik.touched.DateOfBirth &&
                    Boolean(formik.errors.DateOfBirth)
                  }
                  helperText={
                    formik.touched.DateOfBirth && formik.errors.DateOfBirth
                  }
                />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              label="Date of Joining"
              inputFormat="DD-MM-YYYY"
              value={
                formik.values.DateJoining
                  ? dayjs(formik.values.DateJoining)
                  : null
              }
              onChange={(v) => {
                formik.setFieldValue(
                  "DateJoining",
                  v && dayjs(v).isValid() ? dayjs(v).format("YYYY-MM-DD") : "",
                );
              }}
              onClose={() => formik.setFieldTouched("DateJoining", true)}
              renderInput={(params) => (
                <TextField
                  size="small"
                  {...params}
                  sx={{ flex: 1 }}
                  error={
                    formik.touched.DateJoining &&
                    Boolean(formik.errors.DateJoining)
                  }
                  helperText={
                    formik.touched.DateJoining && formik.errors.DateJoining
                  }
                />
              )}
            />
          </LocalizationProvider>
        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          sx={{ mb: 2 }}
          spacing={{ xs: 2, sm: 4 }}
        >
          <TextField
            size="small"
            type="number"
            label="Allowance"
            variant="outlined"
            sx={{ flex: 1 }}
            name="Allowance"
            value={formik.values.Allowance}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.Allowance && Boolean(formik.errors.Allowance)}
            helperText={formik.touched.Allowance && formik.errors.Allowance}
          />
          <TextField
            size="small"
            type="number"
            label="First Salary"
            variant="outlined"
            sx={{ flex: 1 }}
            name="FirstSalary"
            value={formik.values.FirstSalary}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.FirstSalary && Boolean(formik.errors.FirstSalary)
            }
            helperText={formik.touched.FirstSalary && formik.errors.FirstSalary}
          />
          <TextField
            size="small"
            type="number"
            label="Salary Demand"
            variant="outlined"
            sx={{ flex: 1 }}
            name="SalaryDemand"
            value={formik.values.SalaryDemand}
            onChange={formik.handleChange}
          />
        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          sx={{ mb: 2 }}
          spacing={{ xs: 2, sm: 4 }}
        >
          <TextField
            size="small"
            select
            label="Qualification"
            variant="outlined"
            sx={{ flex: 1 }}
            name="QualificationId"
            value={formik.values.QualificationId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.QualificationId &&
              Boolean(formik.errors.QualificationId)
            }
            helperText={
              formik.touched.QualificationId && formik.errors.QualificationId
            }
          >
            {qualifications.map((q) => (
              <MenuItem key={q.QualificationId} value={q.QualificationId}>
                {q.Qualification}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            size="small"
            select
            label="Certificate"
            variant="outlined"
            sx={{ flex: 1 }}
            name="CertificateId"
            value={formik.values.CertificateId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.CertificateId &&
              Boolean(formik.errors.CertificateId)
            }
            helperText={
              formik.touched.CertificateId && formik.errors.CertificateId
            }
          >
            {certifications.map((c) => (
              <MenuItem key={c.CertificateId} value={c.CertificateId}>
                {c.CertificateName}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            size="small"
            select
            label="Experience of Teaching in Years"
            variant="outlined"
            sx={{ flex: 1 }}
            name="ExperienceOfTeaching"
            disabled={isNonTeaching(formik.values.TeachersDesignationId)}
            value={formik.values.ExperienceOfTeaching}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.ExperienceOfTeaching &&
              Boolean(formik.errors.ExperienceOfTeaching)
            }
            helperText={
              formik.touched.ExperienceOfTeaching &&
              formik.errors.ExperienceOfTeaching
            }
          >
            {EXPERIENCE_OPTIONS.map((opt) => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </TextField>
        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          sx={{ mb: 2 }}
          spacing={{ xs: 2, sm: 4 }}
        >
          <TextField
            size="small"
            select
            label="Subject of Experience"
            variant="outlined"
            sx={{ flex: 1 }}
            name="SubjectOfExperience"
            value={formik.values.SubjectOfExperience}
            onChange={formik.handleChange}
          >
            {(subjects || []).map((s) => (
              <MenuItem key={s.ID} value={s.SubjectName}>
                {s.SubjectName}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            size="small"
            select
            label="Hired Subject"
            variant="outlined"
            sx={{ flex: 1 }}
            name="HiredSubject"
            value={formik.values.HiredSubject}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.HiredSubject && Boolean(formik.errors.HiredSubject)
            }
            helperText={
              formik.touched.HiredSubject && formik.errors.HiredSubject
            }
          >
            {(subjects || []).map((s) => (
              <MenuItem key={s.ID} value={String(s.ID)}>
                {s.SubjectName}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            size="small"
            label="Bank Account"
            variant="outlined"
            sx={{ flex: 1 }}
            name="BankAccount"
            value={formik.values.BankAccount}
            onChange={formik.handleChange}
          />
        </Stack>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          sx={{ mb: 2 }}
          spacing={{ xs: 2, sm: 4 }}
        >
          <TextField
            size="small"
            select
            label="Primary / Secondary"
            variant="outlined"
            sx={{ flex: 1 }}
            name="IsPrimary"
            disabled={isNonTeaching(formik.values.TeachersDesignationId)}
            // value={formik.values.IsPrimary}
            value={
              isNonTeaching(formik.values.TeachersDesignationId)
                ? "None"
                : formik.values.IsPrimary
            }
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.IsPrimary && Boolean(formik.errors.IsPrimary)}
            helperText={formik.touched.IsPrimary && formik.errors.IsPrimary}
          >
            <MenuItem value="">Select</MenuItem>
            <MenuItem value="Primary">Primary</MenuItem>
            <MenuItem value="Secondary">Secondary</MenuItem>
            <MenuItem value="KG">KG</MenuItem>
            <MenuItem value="None">None</MenuItem>
          </TextField>
        </Stack>

        <Box sx={{ mt: 3 }}>
          <LoadingButton variant="contained" fullWidth type="submit">
            Save
          </LoadingButton>
        </Box>
      </Box>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snack.open}
        autoHideDuration={6000}
        onClose={snack_handleClose}
      >
        <Alert
          onClose={snack_handleClose}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
